<template>
  <div class="w-100 p-2 mt-2">
    <page-header :name="'Dashboard'">
      <i class="fas fa-clipboard-list"></i> {{ $t('page.title.dashboard') }}
    </page-header>
    <div v-if="isBusy" class="spinner-wrapper">
      <b-spinner></b-spinner>
    </div>
    <section class="content" v-if="!isBusy">
      <div class="sygni-grid">
        <div class="row mb-5">
          <div class="col-4">
            <b-form-group :label="$t('crm.dashboard.input.period')" label-for="input-2">
              <date-range-picker v-model="dateRange"
                                 ref="picker"
                                 opens="right"
                                 :auto-apply="true"
                                 :time-picker-increment="1"
                                 @update="getStatistics">
              </date-range-picker>
            </b-form-group>
          </div>
        </div>

        <div class="row">
          <div class="col-6">
            <div class="info-box flex-column bg-gradient-primary mb-3">
              <h5 class="ml-3">{{$t('crm.dashboard.title.registered_players')}}</h5>
              <div class="d-flex">
                <span class="info-box-icon">
                  <b-icon-person-plus-fill></b-icon-person-plus-fill>
                </span>
                <div class="info-box-content">
                  <div class="d-flex flex-row align-items-center justify-content-between mb-3">
                    <span>{{$t(`crm.dashboard.${playersTypes.withoutDepositsAndGames}`)}}</span>
                    <div class="d-flex align-items-center justify-content-end">
                      <span class="text-bold">{{ statistics[playersTypes.withoutDepositsAndGames] }}</span>
                      <button @click="createSegment(playersTypes.withoutDepositsAndGames)" class="btn btn-warning btn-sm ml-4">{{$t('crm.dashboard.btn.segment')}}</button>
                    </div>
                  </div>

                  <div class="d-flex flex-row align-items-center justify-content-between">
                    <span>{{$t(`crm.dashboard.${playersTypes.withoutDepositsWithFunGames}`)}}</span>
                    <div class="d-flex align-items-center justify-content-end">
                      <span class="text-bold">{{ statistics[playersTypes.withoutDepositsWithFunGames] }}</span>
                      <button @click="createSegment(playersTypes.withoutDepositsWithFunGames)" class="btn btn-warning btn-sm ml-4">{{$t('crm.dashboard.btn.segment')}}</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="info-box flex-column bg-gradient-info mb-3">
              <h5 class="ml-3">{{$t('crm.dashboard.title.conversions_ftd')}}</h5>
              <div class="d-flex">
                <span class="info-box-icon">
                  <b-icon-shuffle></b-icon-shuffle>
                </span>
                <div class="info-box-content">
                  <div class="d-flex flex-row align-items-center justify-content-between">
                    <span>{{$t(`crm.dashboard.${playersTypes.withFtd}`)}}</span>
                    <div class="d-flex align-items-center justify-content-end">
                      <span class="text-bold">{{ statistics[playersTypes.withFtd] }}</span>
                      <button @click="createSegment(playersTypes.withFtd)" class="btn btn-warning btn-sm ml-4">{{$t('crm.dashboard.btn.segment')}}</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-6">
            <div class="info-box flex-column bg-gradient-navy mb-3">
              <h5 class="ml-3">{{$t('crm.dashboard.title.deposits')}}  </h5>
              <div class="d-flex">
                <span class="info-box-icon">
                  <b-icon-cash-stack></b-icon-cash-stack>
                </span>
                <div class="info-box-content">
                  <div class="d-flex flex-row align-items-center justify-content-between mb-3">
                    <span>{{$t(`crm.dashboard.${playersTypes.withOneDeposit}`)}}</span>
                    <div class="d-flex align-items-center justify-content-end">
                      <span class="text-bold">{{ statistics[playersTypes.withOneDeposit] }}</span>
                      <button @click="createSegment(playersTypes.withOneDeposit)" class="btn btn-warning btn-sm ml-4">{{$t('crm.dashboard.btn.segment')}}</button>
                    </div>
                  </div>
                  <div class="d-flex flex-row align-items-center justify-content-between mb-3">
                    <span>{{$t(`crm.dashboard.${playersTypes.withMoreThanOneDeposits}`)}}</span>
                    <div class="d-flex align-items-center justify-content-end">
                      <span class="text-bold">{{ statistics[playersTypes.withMoreThanOneDeposits] }}</span>
                      <button @click="createSegment(playersTypes.withMoreThanOneDeposits)" class="btn btn-warning btn-sm ml-4">{{$t('crm.dashboard.btn.segment')}}</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    </div>
</template>

<script>

import axios from "axios";
import PageHeader from "../../components/page/PageHeader";
import { mapState } from 'vuex';
import DateRangePicker from "../../components/DateRangePicker/components/DateRangePicker";
import moment from "moment";
import {userSegment} from "../../common/constants/userSegment";

export default {
  components: {PageHeader, DateRangePicker},
  data() {
    return {
      playersTypes: {
        withoutDepositsAndGames: 'players_amount_without_deposits_and_games',
        withoutDepositsWithFunGames: 'players_amount_without_deposits_with_fun_games',
        withOneDeposit: 'players_amount_with_one_deposit',
        withMoreThanOneDeposits: 'players_amount_with_more_than_one_deposits',
        withFtd: 'players_amount_with_ftd'
      },
      filterQuery: [],
      dateRange: {},
      userSegment: null
    };
  },
  mounted() {
    this.userSegment = userSegment;

    this.dateRange.startDate = moment().format('YYYY-MM-DD');
    this.dateRange.endDate = moment().format('YYYY-MM-DD');

    axios.defaults.headers.common['X-AUTH-TOKEN'] = this.apiKey;

    this.getStatistics();
  },
  computed: {
    ...mapState({
      statistics: (state) => state.crmDashboardStore.statistics,
      isBusy: (state) => state.crmDashboardStore.isBusy
    }),
    apiKey: function () {
      return this.$store.getters["root/apiKey"];
    }
  },
  methods: {
    getStatistics() {
      const dateRange = {
        startDate: this.dateRange.startDate ? moment(this.dateRange.startDate).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD'),
        endDate: this.dateRange.endDate ? moment(this.dateRange.endDate).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD')
      }

      this.$store.dispatch('crmDashboardStore/getStatistics', dateRange);
    },
    createSegment(playersType) {
      let segmentsConfig;

      const dateRange = {
        startDate: this.dateRange.startDate ? moment(this.dateRange.startDate).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD'),
        endDate: this.dateRange.endDate ? moment(this.dateRange.endDate).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD')
      }

      switch(playersType) {
        case this.playersTypes.withoutDepositsAndGames:
          segmentsConfig = {
            dateRange: dateRange,
            segments: {
              [this.userSegment.game]: {
                operator: 'LTE',
                amount: '0',
              },
              [this.userSegment.paymentTotalDeposited]: {
                operator: 'LTE',
                amount: '0',
              }
            }
          }
          break;
        case this.playersTypes.withoutDepositsWithFunGames:
          segmentsConfig = {
            dateRange: dateRange,
            segments: {
              [this.userSegment.game]: {
                operator: 'GT',
                amount: '1',
              },
              [this.userSegment.paymentTotalDeposited]: {
                operator: 'LTE',
                amount: '0',
              }
            }
          }
          break;
        case this.playersTypes.withOneDeposit:
          segmentsConfig = {
            dateRange: dateRange,
            segments: {
              [this.userSegment.game]: {
                operator: 'LTE',
                amount: '1',
              },
              [this.userSegment.paymentTotalDeposited]: {
                operator: 'GTE',
                amount: '1',
              }
            }
          }
          break;
        case this.playersTypes.withMoreThanOneDeposits:
          segmentsConfig = {
            dateRange: dateRange,
            segments: {
              [this.userSegment.paymentTotalDeposited]: {
                operator: 'GTE',
                amount: '1',
              }
            }
          }
          break;
        case this.playersTypes.withFtd:
          segmentsConfig = {
            dateRange: dateRange,
            segments: {
              [this.userSegment.paymentTotalDeposited]: {
                operator: 'GTE',
                amount: '1',
              }
            }
          }
          break;
        default:
          // code block
      }

      this.$store.commit('crmDashboardStore/newSegmentParams', segmentsConfig);

      this.$router.push({ name: `user-segment-list`, params: { openCreateSegmentModal: true } });
    }
  },
}
</script>
